module.exports = __webpack_public_path__ + "img/AllConnect.3fc184bc.png";